export {
  MorphemeMnemonicsPanelTranscriptionTabButton,
  type MorphemeMnemonicsPanelTranscriptionTabButtonProps,
} from "#morpheme-mnemonics-panel-transcription-tab-button";
